import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CountryForm from '../../../components/forms/CountryForm';
import { useCountryById, useUpdateCountry } from '../../../hooks/useCountryApi';
import { useNavigate, useParams } from 'react-router-dom';
import { CountryDTO } from '../../../services/apiClient';

const CountryEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useCountryById(id!);
  const updateCountry = useUpdateCountry();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Countries', href: '/admin/countries' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateCountry.mutateAsync({ id: id!, data });
      navigate('/admin/countries');
    } catch (error) {
      console.error('Error updating Country:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/countries"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.Country.Edit'
    >
        {entityData ? (
          <CountryForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/countries')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CountryEdit;